var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#32A840",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.94 10.2098L17.53 15.8198H15.12C14.72 15.8198 14.33 15.8498 13.95 15.9298L14.95 13.5298L14.99 13.4398L15.05 13.2798C15.08 13.2098 15.1 13.1498 15.13 13.0998C16.29 10.4098 17.59 9.56983 19.94 10.2098Z",
    fill: "#32A840"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.73 16.09L26.71 16.08C26.11 15.91 25.5 15.82 24.88 15.82H18.62L20.87 10.59L20.9 10.52C21.04 10.57 21.19 10.64 21.34 10.69L23.55 11.62C24.78 12.13 25.64 12.66 26.17 13.3C26.26 13.42 26.34 13.53 26.42 13.66C26.51 13.8 26.58 13.94 26.62 14.09C26.66 14.18 26.69 14.26 26.71 14.35C26.86 14.86 26.87 15.44 26.73 16.09Z",
    fill: "#32A840"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.52 25.6601H20.77C21.07 25.6601 21.32 25.3901 21.32 25.0601C21.32 24.6401 21.2 24.5801 20.94 24.4801L20.52 24.3301V25.6601Z",
    fill: "#32A840"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.29 17.5198C25.84 17.3898 25.37 17.3198 24.88 17.3198H15.12C14.44 17.3198 13.8 17.4498 13.2 17.7098C11.46 18.4598 10.24 20.1898 10.24 22.1998V24.1498C10.24 24.3898 10.26 24.6198 10.29 24.8598C10.51 28.0398 12.21 29.7398 15.39 29.9498C15.62 29.9798 15.85 29.9998 16.1 29.9998H23.9C27.6 29.9998 29.55 28.2398 29.74 24.7398C29.75 24.5498 29.76 24.3498 29.76 24.1498V22.1998C29.76 19.9898 28.29 18.1298 26.29 17.5198ZM21.28 23.4998C21.74 23.6598 22.36 23.9998 22.36 25.0598C22.36 25.9698 21.65 26.6998 20.77 26.6998H20.52V26.9198C20.52 27.2098 20.29 27.4398 20 27.4398C19.71 27.4398 19.48 27.2098 19.48 26.9198V26.6998H19.39C18.43 26.6998 17.64 25.8898 17.64 24.8898C17.64 24.5998 17.87 24.3698 18.16 24.3698C18.45 24.3698 18.68 24.5998 18.68 24.8898C18.68 25.3098 19 25.6598 19.39 25.6598H19.48V23.9698L18.72 23.6998C18.26 23.5398 17.64 23.1998 17.64 22.1398C17.64 21.2298 18.35 20.4998 19.23 20.4998H19.48V20.2798C19.48 19.9898 19.71 19.7598 20 19.7598C20.29 19.7598 20.52 19.9898 20.52 20.2798V20.4998H20.61C21.57 20.4998 22.36 21.3098 22.36 22.3098C22.36 22.5998 22.13 22.8298 21.84 22.8298C21.55 22.8298 21.32 22.5998 21.32 22.3098C21.32 21.8898 21 21.5398 20.61 21.5398H20.52V23.2298L21.28 23.4998Z",
    fill: "#32A840"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6801 22.14C18.6801 22.56 18.8001 22.62 19.0601 22.72L19.4801 22.87V21.54H19.2301C18.9201 21.54 18.6801 21.81 18.6801 22.14Z",
    fill: "#32A840"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.c83aafa229b42345dd0964d367842b4b.svg";
export { ForwardRef as ReactComponent };